export default {
  methods: {
    scrollTo: function (element, to, duration, clear) {
      if (to < 0) to = 0
      const difference = to - element.scrollTop
      const perTick = duration ? difference / duration * 10 : difference / 10
      if (clear) {
        clearTimeout(this.setTimeoutId)
      }
      this.setTimeoutId = setTimeout(() => {
        element.scrollTop = duration ? element.scrollTop + perTick : to
        if (element.scrollTop <= 0) {
          element.scrollTop = 0
          return false
        }
        if (element.scrollTop === to || !duration) return
        this.scrollTo(element, to, duration - 10)
      }, 10)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/scrollTo.js